import type { SkillInvocationAttribution } from "../../../common/types";

export const GATE_BLOCK_PATTERNS = [
  /\bnot enabled\b/i,
  /\bnot configured\b/i,
  /\brequires .*authentication\b/i,
  /\brequires .*login\b/i,
  /\bcontact .*administrator\b/i,
];

export type AttributionRenderState = "success" | "blocked" | "error";

export const getAttributionSummary = (
  attribution: SkillInvocationAttribution,
) => attribution.error || attribution.output_summary || "No output summary";

export const getAttributionState = (
  attribution: SkillInvocationAttribution,
): AttributionRenderState => {
  const summary = getAttributionSummary(attribution);
  if (
    attribution.result_status === "blocked" ||
    attribution.error_code?.includes("not_enabled") ||
    attribution.error_code?.includes("not_configured") ||
    GATE_BLOCK_PATTERNS.some((pattern) => pattern.test(summary))
  ) {
    return "blocked";
  }
  if (attribution.success && !attribution.error) return "success";
  return "error";
};

export const resolveDisplayedAttributions = (
  persisted: SkillInvocationAttribution[],
  fallback: SkillInvocationAttribution[],
): SkillInvocationAttribution[] => {
  if (fallback.some((item) => getAttributionState(item) !== "success")) {
    return fallback;
  }
  return persisted.length > 0 ? persisted : fallback;
};
